import {createAction} from "redux-actions";
import * as constants from "./constants";

export const getTransactionDetail = createAction(constants.GET_TRANSACTION_DETAIL.REQUEST, (filters) => (filters));
export const clearState = createAction(constants.CLEAR_STATE);
export const updateTransaction = createAction(constants.UPDATE_TRANSACTION, (id, data) => ({id, data}));

